import { JobApplicationStatus } from '../../domain/types';
import { JobApplication } from '../../providers/api/dtos/jobApplication';

const restorableStatus = [
  JobApplicationStatus.TALENT_POOL,
  JobApplicationStatus.KO_UNREACHABLE,
  JobApplicationStatus.KO_NOT_INTERESTED,
  JobApplicationStatus.KO_OFFER_REFUSED,
  JobApplicationStatus.KO_WRONG_NUMBER,
];

export const activeStatus = [
  JobApplicationStatus.IN_PROGRESS,
  JobApplicationStatus.ASSIGNED,
  JobApplicationStatus.INTERVIEW_SCHEDULED,
  JobApplicationStatus.OFFER,
  JobApplicationStatus.HIRED,
];

export function isRestorable(jobApplication: JobApplication): Boolean;
export function isRestorable(status: JobApplicationStatus): Boolean;

export function isRestorable(arg: JobApplication | JobApplicationStatus): Boolean {
  const status = (arg as JobApplication).status
    ? (arg as JobApplication).status
    : arg as JobApplicationStatus;

  return restorableStatus.includes(status);
}

export function isActive(jobApplication: JobApplication): Boolean;
export function isActive(status: JobApplicationStatus): Boolean;

export function isActive(arg: JobApplication | JobApplicationStatus): Boolean {
  const status = (arg as JobApplication).status
    ? (arg as JobApplication).status
    : arg as JobApplicationStatus;

  return activeStatus.includes(status);
}
